<template>
  <div>
    <div class="p-4 bg-secondary text-white">
      <h4 class="uppercase mb-0">{{ $t('titles.customization') }}</h4>
    </div>
    <div class="p-4">
      <div class="flex flex-row flex-wrap justify-center mb-3 -mx-2">
        <div v-for="(product_variant, index) in currentTurretProductVariants" class="w-full lg:w-1/2 px-2 mb-3">
          <label
            class="card transition mb-4 lg:mb-0 font-normal normal-case"
            :class="{'is-selected': isSelected(product_variant.id) }">
            <div class="p-4 flex items-center border-b relative">
              <div class="w-1/4 pr-3">
                <img :src="product_variant.image_url" class="w-full" />
              </div>
              <div class="w-3/4">
                <h5 class="font-bold uppercase text-sm mb-1">
                  {{ product_variant.name }}
                  <div class="absolute top-2 right-2" :class="{'hidden': !isSelected(product_variant.id)}">
                    <i class="fas fa-check-circle text-primary"></i>
                  </div>
                </h5>
                <p class="text-xs sm:text-sm text-gray-700">{{ product_variant.description }}</p>
              </div>
              <!-- This isn't submitted, only manages state -->
              <input type="radio" v-model="currentScopeProductVariant" name="turret_customization[product_variant]" :value="product_variant.id" class="hidden" hidden>
            </div>
            <div class="p-4 text-center">
              <div class="font-bold text-lg">${{ formatPrice(product_variant.price) }} CAD</div>
              <span class="text-gray-700 text-sm font-semibold ">
                ${{ priceInUsd(product_variant.price) }} USD
                <i class="fas fa-question-circle text-primary"
                  v-tippy="{ arrow : true,  animation : 'shift-away'}"
                  :content=conversionRateText>
                </i>
              </span>
            </div>
          </label>
        </div>
        <!-- Hidden product_variant_id input data binding to currentScopeProductVariant model -->
        <input name="turret_customization[product_variant_id]" type="text" :value="currentScopeProductVariantId" class="hidden" hidden>
      </div>
      <div class="p-4 bg-gray-100 text-center border rounded text-sm text-gray-700 mt-3" v-html="turretCustomizationEnabled ? $t('turretCustomizer.customizationType.customFormHint') : $t('turretCustomizer.customizationType.formHint')">
       
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex"
import { priceInUsd, formatPrice } from "../module/constants"

const { mapGetters } = createNamespacedHelpers("turretCustomizer")

export default {
  props: ["conversionRate", "turretCustomizationEnabled"],
  computed: {
    ...mapGetters(["permittedCurrentScope", "currentBrand"]),
    currentScopeProductVariant: {
      get() {
        return this.$store.getters["turretCustomizer/currentScopeProductVariant"]
      },
      set(newSelectedProductVariantId) {
        this.$store.dispatch("turretCustomizer/updateCurrentScopeProductVariant", newSelectedProductVariantId)
      }
    },
    currentScopeProductVariantId() {
      return this.currentScopeProductVariant.id
    },
    currentTurretProductVariants() {
      return this.permittedCurrentScope.turret.product_variants
    },
    conversionRateText() {
      return `1 CAD = ~${this.conversionRate.toFixed(5)} USD`
    }
  },
  methods: {
    isSelected(id) {
      return this.currentScopeProductVariant.id === id
    },
    priceInUsd(price) {
      return priceInUsd(price, this.conversionRate)
    },
    formatPrice(price) {
      return formatPrice(price)
    }
  }
}
</script>
